export const colors = {
	primary: "#CC1B0B",
};
